import { render, staticRenderFns } from "./BoardsPage.vue?vue&type=template&id=312fdd9c&scoped=true&"
import script from "./BoardsPage.vue?vue&type=script&lang=js&"
export * from "./BoardsPage.vue?vue&type=script&lang=js&"
import style0 from "./BoardsPage.vue?vue&type=style&index=0&id=312fdd9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312fdd9c",
  null
  
)

export default component.exports